// extracted by mini-css-extract-plugin
export var button = "_6r-0";
export var icon = "_6r-1";